// removed by extract-text-webpack-plugin
module.exports = {"GlobalModal":"GlobalModal---2Ok_R","GlobalModalContent":"GlobalModalContent---2auUJ","GlobalModalButtonContainer":"GlobalModalButtonContainer---2N4BC"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/GlobalModal/style.styl
// module id = dIjX
// module chunks = 89